// 页面初始隐藏，添加渐隐效果 //
window.addEventListener('load', function() {
  document.body.style.opacity = 1;
});
//Announcement Bar
document.addEventListener('DOMContentLoaded', function () {
  const menuIcon = document.getElementById('menuIcon'); // 菜单按钮
  const announcementBar = document.getElementById('announcementBar'); // 公告栏
  const header = document.querySelector('header'); // 你的导航栏
  const scrollHeight = announcementBar.offsetHeight; // 获取公告栏的高度

  menuIcon.addEventListener('click', function () {
    const announcementRect = announcementBar.getBoundingClientRect(); // 获取公告栏的位置
    const headerRect = header.getBoundingClientRect(); // 获取导航栏的位置

    if (announcementRect.bottom > 0) {
      // 如果公告栏仍然部分或完全可见，滚动页面直到 header 顶端与窗口对齐
      const scrollOffset = headerRect.top; // 计算当前 header 顶部距离窗口的距离
      window.scrollBy({
        top: scrollOffset, // 滚动到 header 顶部对齐
        behavior: 'smooth' // 平滑滚动
      });

      // 延迟一段时间，确保滚动结束后再打开菜单
      setTimeout(() => {
        toggleMobileMenu(); // 调用你的菜单展开函数
      }, 500);
    } else {
      // 如果公告栏已经完全移出屏幕，直接打开菜单
      toggleMobileMenu();
    }
  });

  function toggleMobileMenu() {
    // 你的菜单展开/关闭逻辑
    menuIcon.classList.toggle('open');
  }
});

// 特殊翻译
document.addEventListener('DOMContentLoaded', () => {
  // 检测货币函数
  function detectShopifyCurrency() {
    let currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "AUD";
    console.log("Detected currency:", currency);
    return currency;
  }

  // 获取货币
  const currentCurrency = detectShopifyCurrency();
  // 如果货币不是 CNY，则不执行翻译逻辑
  if (currentCurrency !== "CNY") {
    console.log("The current currency is not CNY, no translation will be performed.");
    return;
  }
  console.log("The current currency is CNY, perform translation");

  // 定义文本替换函数，只有在文本中包含待替换关键词时才进行替换
  function replaceText(text) {
    if (!/(Metal|18K Yellow Gold|18K White Gold|18K Rose Gold)/.test(text)) {
      return text;
    }
    return text
      .replace(/Metal/g, '金属材质')
      .replace(/18K Yellow Gold/g, '18K黄金')
      .replace(/18K White Gold/g, '18K白金')
      .replace(/18K Rose Gold/g, '18K玫瑰金');
  }

  // 递归遍历DOM节点进行文本替换
  function translateNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const originalText = node.nodeValue;
      const newText = replaceText(originalText);
      if (newText !== originalText) {
        node.nodeValue = newText;
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      node.childNodes.forEach(child => translateNode(child));
    }
  }

  // 初次翻译整个页面
  translateNode(document.body);

  // 定义 MutationObserver
  const observer = new MutationObserver((mutations) => {
    // 暂时断开 observer，防止修改引发无限循环
    observer.disconnect();
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => translateNode(node));
      } else if (mutation.type === 'characterData') {
        translateNode(mutation.target);
      }
    });
    // 处理完成后重新开始观察
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  });

  // 开始观察 DOM 变化，包括文本节点变化
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
});
